export default __webpack_public_path__ + "static/aisuko-li-layer5-maintainer-bb2d2ad59f6d8d33c4684068cf908978.png";